// After a form comes back with validation errors, move keyboard focus to the
// first invalid field. Screen readers then announce its label, "invalid", and
// the linked error message (aria-describedby, see
// config/initializers/field_error_proc.rb) — instead of leaving the user at
// the top of a re-rendered page with no hint that anything went wrong.

function focusFirstInvalid() {
  const field = document.querySelector("[aria-invalid='true']")
  if (field && !field.contains(document.activeElement)) field.focus()
}

// Full-page renders: normal visits and 422 re-renders of a form.
document.addEventListener("turbo:load", focusFirstInvalid)
document.addEventListener("turbo:render", focusFirstInvalid)

// In-place Turbo Stream updates (e.g. the portfolio editor's section forms).
document.addEventListener("turbo:before-stream-render", (event) => {
  const render = event.detail.render
  event.detail.render = async (streamElement) => {
    await render(streamElement)
    focusFirstInvalid()
  }
})
